import React from "react";
import PointGuideModalState, { PointGuideModalProps } from "./PointGuideModal.models";
import './PointGuideModal.scss';
import { Modal } from "react-bootstrap";
import PointsService from "../../../services/management/PointsService";

export default class PointGuideModal extends React.PureComponent<PointGuideModalProps, PointGuideModalState> {

    pointsService: PointsService;
    constructor(props: any) {
        super(props);
        this.pointsService = new PointsService();
        this.state = { pointInfo: { description: '', id: 0, point: 0, pointTitle: '' } };
    }

    componentDidMount = () => {
        this.getData();
    }

    componentDidUpdate = (prevProps: any) => {
        if (prevProps.pointId !== this.props.pointId)
            this.getData();
    }

    getData = () => {
        let self = this;
        if (this.props.pointId !== 0)
            self.pointsService.getPointDetail(this.props.pointId).then(function (response) {
                self.setState({ pointInfo: response });
            });
    }

    render(): React.ReactNode {
        let { closeModal, showModal } = this.props;
        let { pointInfo } = this.state;
        return (<>
            <Modal show={showModal} onHide={closeModal} animation={true}>
                <Modal.Header >
                    <Modal.Title>
                        <label>مشاهده جزئیات</label>
                    </Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <div className="col-12">
                        <div className="row">
                            <div className="col-4">
                                <label> عنوان :</label>
                            </div>
                            <div className="col-8" style={{ textAlign: "left" }}>
                                <label style={{ color: "orange" }}>{pointInfo.pointTitle}</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <div className="row">
                            <div className="col-4">
                                <label> امتیاز :</label>
                            </div>
                            <div className="col-8" style={{ textAlign: "left" }}>
                                <label style={{ color: "orange" }}>{pointInfo.point}</label>
                            </div>
                        </div>
                    </div>

                    <div className="col-12">
                        <label style={{ display: "block" }}> توضیحات : </label>
                        <label style={{ color: "orange", fontSize: "14px" }}>{pointInfo.description}</label>
                    </div>
                </Modal.Body >

                <Modal.Footer dir="ltr">
                    <button className="btn btn btn-danger tk-float-left" onClick={closeModal}>بستن</button>
                </Modal.Footer>
            </Modal >
        </>);
    }
}